// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XvQQ","badges":"styles_badges__CTI7D"};